export default "__VITE_ASSET__B$EsUl0E__"